import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ffc23d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-booking-history mb-4" }
const _hoisted_2 = { class: "list-header" }
const _hoisted_3 = { class: "list-body mt-5" }
const _hoisted_4 = { class: "font-lms-regular-15" }

import { inject, onBeforeMount, ref } from "vue";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { ApiBookingIndexRes, ApiListBookingHistoryReq } from "@/clinic/typings";
import { BookingServices } from "@/clinic/services";
import { AxiosResponse } from "axios";
import { AnyFn, Fn, get, set, useDateFormat } from "@vueuse/core";
import { BookingActionEnum } from "@/clinic/typings/enums/booking";
import { DATE_FORMAT, TIME_FORMAT } from "@/clinic/typings/constants/booking";
import SearchForm from "./search-form.vue";
import { IBooking } from "@/clinic/typings/entities/booking";
import NumberUtils from "@/clinic/utils/number-utils";
import { PageState } from "primevue/paginator";
import { EventClickArg, EventInput } from "@fullcalendar/core";
import TimeUtils from "@/clinic/utils/time-utils";
import { CustomerStatusesConstants } from "@/clinic/constants/customer.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'list-booking-history',
  setup(__props, { expose }) {

const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(1);
const bookingDatas = ref<IBooking[]>([]);
const sortStartTime = async () => {
  set(sortBy, "start_time");
  set(sortDirStartTime, get(sortDirStartTime) === "asc" ? "desc" : "asc");

  await onLoadBooking();
};

const sortCreatedAt = async () => {
  set(sortBy, "created_at");
  set(sortDirCreatedAt, get(sortDirCreatedAt) === "asc" ? "desc" : "asc");

  await onLoadBooking();
};
const columns = [
  { field: "id", header: "予約ID", class: "col-fixed", style: "width: 108px" },
  { field: "booking_type_display", header: "予約形態", class: "col-fixed", style: "width: 120px" },
  { field: "customer_name", header: "予約者名", class: "col-2" },
  { field: "created_at", header: "予約を入れた日時", class: "col-2", sort: sortCreatedAt },
  { field: "start_time", header: "予約日時", sort: sortStartTime },
  { field: "menu_name", header: "メニュー" },
  { field: "price", header: "価格" },
  { field: "status_name", header: "ステータス" },
];

const status = ref("");
const bookingType = ref("");
const term = ref("");
const kanaTerm = ref("");
const phoneTerm = ref("");
const startTime = ref();
const endTime = ref();
const medicalMenuId = ref();
const loading = ref(false);
const first = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
const onShowBookingSidebar = ref<AnyFn>();
const clinicId = ref();
const sortBy = ref("start_time");
const sortDirStartTime = ref("desc");
const sortDirCreatedAt = ref("desc");

const paging = async (fromId: string, { page: newPage }: PageState) => {
  const pgRef = fromId == "pg-top" ? get(pgTop)?.getPagination() : get(pgBot)?.getPagination();
  // PrimeVueのPaginatorは0ベースのページ番号を返すため、1ベースに変換
  const apiPage = newPage + 1;
  if (apiPage === get(page)) return;
  set(page, apiPage);
  await onLoadBooking(pgRef as any, newPage);
};

const paginatorParams = async (): Promise<ApiListBookingHistoryReq> => ({
  start_time: !startTime.value ? "" : get(useDateFormat(get(startTime), DATE_FORMAT)),
  end_time: !endTime.value ? "" : get(useDateFormat(get(endTime), DATE_FORMAT)),
  start_hour: !startTime.value ? "" : get(useDateFormat(get(startTime), TIME_FORMAT)),
  end_hour: !endTime.value ? "" : get(useDateFormat(get(endTime), TIME_FORMAT)),
  term: get(term),
  kana_term: get(kanaTerm),
  phone_term: get(phoneTerm),
  status: status.value == "default" ? "" : get(status.value),
  clinic_id: get(get(clinicId)),
  medical_menu_id: medicalMenuId.value == 0 ? "" : get(medicalMenuId),
  filter_type: get(bookingType) || "", // 予約形態フィルターパラメータ（既存のRails API仕様に合わせて修正）
  rows: DEFAULT_PAGINATOR_ROWS,
  page: get(page),
  sort_by: get(sortBy),
  sort_dir: get(sortBy) === "start_time" ? get(sortDirStartTime) : get(sortDirCreatedAt),
});

const onSearch = async (payload: {
  term: string;
  kanaTerm: string;
  phoneTerm: string;
  status: string;
  bookingType: string;
  startTime: Date;
  endTime: Date;
  medicalMenuId: number;
}) => {
  // Update your search parameters based on the payload from SearchForm
  term.value = payload.term;
  kanaTerm.value = payload.kanaTerm;
  phoneTerm.value = payload.phoneTerm;
  status.value = payload.status;
  bookingType.value = payload.bookingType;
  startTime.value = payload.startTime;
  endTime.value = payload.endTime;
  medicalMenuId.value = payload.medicalMenuId;
  // 検索時は1ページ目に戻る（APIは1ベースなので1を設定）
  set(page, 1);
  // ページネーターのUI状態もリセット（0ベースなので0を設定）
  set(first, 0);
  await onLoadBooking();
};

const onLoadBooking = async (pgRef?: { changePage: (page: number) => void } | null, newPage?: number) => {
  set(loading, true);
  const { data } = (await BookingServices.listBookings(
    await paginatorParams()
  )) as unknown as AxiosResponse<ApiBookingIndexRes>;
  const { bookings, meta } = get(data);
  const { total_count } = meta;

  set(bookingDatas, get(bookings));
  set(totalCount, total_count);

  // ページネーターの状態を更新（0ベースのページ番号で更新）
  if (get(totalCount) > get(rows) && pgRef && newPage !== undefined) {
    get(pgRef)?.changePage(newPage);
  }
  set(loading, false);
};

const loadShowSidebar = (bookingId: number) => {
  const id = bookingId;
  if (id == 0) return;

  const showBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg | EventInput) => ({
      _booking,
      _action,
      _eventArg,
    }));
  showBookingSidebarFn({ id } as IBooking, BookingActionEnum.show, {} as EventClickArg);
};

const onItemClick = async (event: Event, item: IBooking) => {
  loadShowSidebar(item.id as number);
};

// eslint-disable-next-line no-undef
expose({
  onLoadBooking,
});

onBeforeMount(async () => {
  set(clinicId, inject("clinicId"));
  set(onShowBookingSidebar, inject<Fn>("onShowBookingSidebar"));
  await onLoadBooking();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchForm, { onSearch: onSearch })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-top",
            ref_key: "pgTop",
            ref: pgTop,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true),
      _createVNode(Grid, {
        items: bookingDatas.value,
        columns: columns,
        loading: loading.value,
        onOnItemClick: onItemClick
      }, {
        booking_type_display: _withCtx(({ data }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["inline-block booking-type-tag border-round-xl text-center px-2 py-1", { 'free-space-booking': data.is_free_space, 'normal-booking': !data.is_free_space }])
          }, _toDisplayString(data.is_free_space ? "自由予約" : "通常予約"), 3)
        ]),
        customer_name: _withCtx(({ data }) => [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["inline-block customer-status border-round-xl text-center mr-1 px-2", data.customer?.status])
            }, _toDisplayString(data.customer_status_display_name ||
                _unref(CustomerStatusesConstants)[data.customer?.status as keyof typeof CustomerStatusesConstants]), 3),
            _createElementVNode("span", null, _toDisplayString(data.customer_name), 1)
          ])
        ]),
        price: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(NumberUtils).formatJPCurrency(parseInt(data.total_amount))), 1)
        ]),
        start_time: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.start_time ? _unref(get)(_unref(TimeUtils).formatDateTimeLocal(data.start_time)) : "承認待ち"), 1)
        ]),
        created_at: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(get)(_unref(TimeUtils).formatDateTimeLocal(data.created_at))), 1)
        ]),
        _: 1
      }, 8, ["items", "loading"])
    ])
  ]))
}
}

})